export default __webpack_public_path__ + "static/media/page3_10.548c418e.png";